module.exports = __webpack_public_path__ + "media/images/convivialite-2-e345161ab7daf97c4cc2782c9c855b77.jpg";